// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"304":"960f1ad4","1102":"e080bf26","6406":"e080bf26"}[chunkId] + ".chunk.css";
};